// Shared chrome for every officer-notebook cell. Title + purpose +
// body slot + optional footer slot. Keeps the 12 cell components
// focused on their content.

import type { ReactNode } from 'react';
export { StatTile } from '@rmint/ui';

type Props = {
  name: string;
  title: string;
  purpose: string;
  status?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
};

export function CellShell({ name, title, purpose, status, children, footer }: Props) {
  return (
    <div className="space-y-4">
      <header className="flex items-baseline justify-between gap-4">
        <div>
          <h3 className="text-lg font-semibold text-foreground">{title}</h3>
          <p className="text-sm text-foreground-mute mt-0.5">{purpose}</p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          {status}
          <code className="text-xs text-foreground-soft">{name}</code>
        </div>
      </header>
      {children}
      {footer ? <footer className="text-xs text-foreground-soft border-t border-border-soft pt-3">{footer}</footer> : null}
    </div>
  );
}

// A minimal "we'll fill this later" body — used by the 9 skeleton
// cells. Conveys intent without pretending to render real data.
export function CellSkeleton({ phaseHint }: { phaseHint: string }) {
  return (
    <div className="rounded-md border border-dashed border-border bg-card-warm p-6 text-sm text-foreground-mute">
      {phaseHint}
    </div>
  );
}

